(function () {
  function ready(fn) {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fn);
    else fn();
  }

  ready(function () {
    if (typeof window.ushareApplyI18n === "function") window.ushareApplyI18n();
    if (!document.querySelector("[data-ushare-hospitals]")) return;
    var root = document;
    var items = window.USHARE_HOSPITALS || [];
    var imgs = window.USHARE_HP_IMGS || {};
    var copy = window.USHARE_HP_COPY || {};
    var cities = copy.cities || {};
    var grid = root.querySelector("[data-hp-grid]");
    var pager = root.querySelector("[data-hp-pager]");
    var cityBox = root.querySelector("[data-city]");
    var cityBtn = root.querySelector("[data-city-toggle]");
    var cityLabel = root.querySelector("[data-city-label]");
    var cityList = root.querySelector("[data-city-list]");
    var deptBox = root.querySelector("[data-dept]");
    var deptBtn = root.querySelector("[data-dept-toggle]");
    var deptLabel = root.querySelector("[data-dept-label]");
    var deptList = root.querySelector("[data-dept-list]");
    var pageSize = 24;
    var city = "";
    var dept = "";
    var page = 1;
    var preferredCities = ["beijing", "shanghai", "guangzhou", "shenzhen", "chengdu", "chongqing"];
    var preferredDepts = [
      "cancer_surgery",
      "cardiology_cardiothoracic",
      "dentistry_oral_maxillofacial",
      "dermatology",
      "endocrinology_metabolism",
      "ent_otolaryngology",
      "gastroenterology_hepatology",
      "hematology",
      "immune_rheumatology",
      "musculoskeletal_orthopedics_spine",
      "nephrology",
      "neurology_neurosurgery",
      "oncology",
      "ophthalmology",
      "pediatrics_congenital_heart",
      "plastic_reconstructive",
      "reproductive_obgyn_andrology",
      "respiratory_thoracic",
      "urology",
      "vascular_surgery"
    ];

    function humanize(code) {
      return String(code || "")
        .replace(/_/g, " ")
        .replace(/\b\w/g, function (c) { return c.toUpperCase(); });
    }
    function labelCity(code) {
      return cities[code] || humanize(code);
    }
    function labelDept(code) {
      return (copy.depts || {})[code] || humanize(code);
    }
    function uniqueKeys(preferred, found) {
      var out = [];
      preferred.forEach(function (k) {
        if (found[k]) out.push(k);
      });
      Object.keys(found).sort().forEach(function (k) {
        if (out.indexOf(k) === -1) out.push(k);
      });
      return out;
    }
    var cityFound = {};
    var deptFound = {};
    items.forEach(function (h) {
      if (h.c) cityFound[h.c] = true;
      (h.depts || []).forEach(function (d) {
        if (d) deptFound[d] = true;
      });
    });
    var keys = uniqueKeys(preferredCities, cityFound);
    var deptKeys = uniqueKeys(preferredDepts, deptFound);

    var params = new URLSearchParams(window.location.search);
    if (params.get("city") && cityFound[params.get("city")]) city = params.get("city");
    if (params.get("dept") && deptFound[params.get("dept")]) dept = params.get("dept");

    function esc(s) {
      return String(s || "").replace(/[&<>"']/g, function (c) {
        return ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c];
      });
    }
    function pinSvg() {
      return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M12 21s7-5.4 7-11a7 7 0 1 0-14 0c0 5.6 7 11 7 11z"/><circle cx="12" cy="10" r="2.4"/></svg>';
    }
    function extSvg() {
      return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M14 4h6v6M10 14 20 4M20 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5"/></svg>';
    }
    function calSvg() {
      return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M8 3v4M16 3v4M3 11h18"/></svg>';
    }
    function deptSvg() {
      return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M3 21h18M6 21V8l6-5 6 5v13M10 21v-6h4v6"/></svg>';
    }
    function arrowSvg() {
      return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
    }
    function checkSvg() {
      return '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><path d="M5 12l5 5L20 7"/></svg>';
    }

    function filtered() {
      return items.filter(function (h) {
        if (city && h.c !== city) return false;
        if (dept && (h.depts || []).indexOf(dept) === -1) return false;
        return true;
      });
    }

    function syncUrl() {
      var u = new URL(window.location.href);
      if (city) u.searchParams.set("city", city);
      else u.searchParams.delete("city");
      if (dept) u.searchParams.set("dept", dept);
      else u.searchParams.delete("dept");
      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, "", u.pathname + u.search + u.hash);
      }
    }

    function renderCity() {
      cityLabel.textContent = city ? labelCity(city) : copy.cityAll;
      var html = '<button type="button" role="option" data-value="" class="' + (!city ? "is-active" : "") + '"><span>' + copy.cityAll + "</span>" + (!city ? checkSvg() : "") + "</button>";
      keys.forEach(function (k) {
        html += '<button type="button" role="option" data-value="' + k + '" class="' + (city === k ? "is-active" : "") + '"><span>' + labelCity(k) + "</span>" + (city === k ? checkSvg() : "") + "</button>";
      });
      cityList.innerHTML = html;
    }

    function renderDept() {
      deptLabel.textContent = dept ? labelDept(dept) : copy.deptAll;
      var html = '<button type="button" role="option" data-value="" class="' + (!dept ? "is-active" : "") + '"><span>' + copy.deptAll + "</span>" + (!dept ? checkSvg() : "") + "</button>";
      deptKeys.forEach(function (k) {
        html += '<button type="button" role="option" data-value="' + k + '" class="' + (dept === k ? "is-active" : "") + '"><span>' + labelDept(k) + "</span>" + (dept === k ? checkSvg() : "") + "</button>";
      });
      deptList.innerHTML = html;
    }

    function render() {
      var list = filtered();
      var pages = Math.max(1, Math.ceil(list.length / pageSize));
      if (page > pages) page = pages;
      var start = (page - 1) * pageSize;
      var slice = list.slice(start, start + pageSize);
      if (!list.length) {
        grid.innerHTML = '<p class="ushare-hp-empty">' + esc(copy.empty || "No hospitals match these filters.") + "</p>";
        pager.innerHTML = "";
        return;
      }
      grid.innerHTML = slice.map(function (h) {
        var src = h.img || imgs[h.i] || "";
        var href = (window.ushareUrl || String)(h.url || "/pages/" + h.s);
        var badges = "";
        if (h.t) badges += '<span class="ushare-hp-badge ushare-hp-badge--tier">' + copy.tertiary + "</span>";
        badges += '<div class="ushare-hp-badges"><span class="ushare-hp-badge ' + (h.p ? "ushare-hp-badge--private" : "ushare-hp-badge--public") + '">' + (h.p ? copy.private : copy.public) + "</span></div>";
        var loc = h.loc ? '<span class="ushare-hp-loc">' + pinSvg() + esc(h.loc) + "</span>" : "";
        var links = '<div class="ushare-hp-links">';
        if (h.w) links += '<a class="ushare-hp-link" href="' + esc(h.w) + '" target="_blank" rel="noopener">' + extSvg() + copy.website + "</a>";
        if (h.k) links += '<a class="ushare-hp-link" href="' + esc(h.k) + '" target="_blank" rel="noopener">' + extSvg() + copy.wiki + "</a>";
        links += "</div>";
        var meta = '<div class="ushare-hp-meta">';
        if (h.y) meta += "<span>" + calSvg() + copy.established.replace("{{ year }}", esc(h.y)) + "</span>";
        if (h.dp) meta += "<span>" + deptSvg() + copy.departments.replace("{{ n }}", esc(h.dp)) + "</span>";
        meta += "</div>";
        var img = src ? '<img src="' + esc(src) + '" alt="' + esc(h.n) + '" width="880" height="520" loading="lazy">' : "";
        return (
          '<article class="ushare-hp-card">' +
            '<div class="ushare-hp-card__photo">' + img + badges + loc + "</div>" +
            '<div class="ushare-hp-card__body">' +
              "<h3>" + esc(h.n) + "</h3>" +
              links +
              "<p>" + esc(h.d || "") + "</p>" +
              meta +
              '<a class="ushare-hp-more" href="' + esc(href) + '">' + copy.view + " " + arrowSvg() + "</a>" +
            "</div>" +
          "</article>"
        );
      }).join("");

      var prevDisabled = page <= 1;
      var nextDisabled = page >= pages;
      var html = '<button type="button" data-page="prev"' + (prevDisabled ? " disabled" : "") + ">" + copy.prev + "</button>";
      for (var i = 1; i <= pages; i++) {
        html += '<button type="button" data-page="' + i + '" class="' + (i === page ? "is-active" : "") + '">' + i + "</button>";
      }
      html += '<button type="button" data-page="next"' + (nextDisabled ? " disabled" : "") + ">" + copy.next + "</button>";
      pager.innerHTML = html;
    }

    function closeBox(box, btn, list) {
      box.classList.remove("is-open");
      btn.setAttribute("aria-expanded", "false");
      list.hidden = true;
    }

    cityBtn.addEventListener("click", function () {
      closeBox(deptBox, deptBtn, deptList);
      var open = cityBox.classList.toggle("is-open");
      cityBtn.setAttribute("aria-expanded", open ? "true" : "false");
      cityList.hidden = !open;
    });
    cityList.addEventListener("click", function (e) {
      var btn = e.target.closest("button[data-value]");
      if (!btn) return;
      city = btn.getAttribute("data-value") || "";
      page = 1;
      closeBox(cityBox, cityBtn, cityList);
      renderCity();
      syncUrl();
      render();
    });
    deptBtn.addEventListener("click", function () {
      closeBox(cityBox, cityBtn, cityList);
      var open = deptBox.classList.toggle("is-open");
      deptBtn.setAttribute("aria-expanded", open ? "true" : "false");
      deptList.hidden = !open;
    });
    deptList.addEventListener("click", function (e) {
      var btn = e.target.closest("button[data-value]");
      if (!btn) return;
      dept = btn.getAttribute("data-value") || "";
      page = 1;
      closeBox(deptBox, deptBtn, deptList);
      renderDept();
      syncUrl();
      render();
    });
    document.addEventListener("click", function (e) {
      if (!cityBox.contains(e.target)) closeBox(cityBox, cityBtn, cityList);
      if (!deptBox.contains(e.target)) closeBox(deptBox, deptBtn, deptList);
    });
    pager.addEventListener("click", function (e) {
      var btn = e.target.closest("button[data-page]");
      if (!btn || btn.disabled) return;
      var v = btn.getAttribute("data-page");
      var pages = Math.max(1, Math.ceil(filtered().length / pageSize));
      if (v === "prev") page = Math.max(1, page - 1);
      else if (v === "next") page = Math.min(pages, page + 1);
      else page = parseInt(v, 10) || 1;
      render();
      root.querySelector(".ushare-hp-list").scrollIntoView({ behavior: "smooth", block: "start" });
    });

    renderCity();
    renderDept();
    render();
  });
})();
